<template>
  <div class="container-fluid py-4 px-4">
    <!--<si-user-table></si-user-table>-->
    <div class="row no-gutters text-left">
      <div class="col">
        <div class="btn-group" role="group" aria-label="Basic example">
          <section id="not-editable" v-if="!isEditable">
            <button type="button" class="btn btn-sm btn-secondary ml-1" @click="goBack">
              <font-awesome-icon icon="undo" />
              <span class="ml-1">Go Back</span>
            </button>

            <button v-if="!isLoading" type="button" class="btn btn-sm btn-primary ml-1" @click="add">
              <font-awesome-icon icon="plus" />
              <span class="ml-1">Add</span>
            </button>

            <button v-if="deletedVessels.length != 0" type="button" class="btn btn-sm btn-danger ml-1" @click="del">
              <font-awesome-icon icon="trash" />
              Remove Vessel
            </button>
          </section>

          <section id="editable" v-if="isEditable">
            <button type="button" class="btn btn-sm btn-success ml-1" @click="save">
              <font-awesome-icon icon="save" />
              <span class="ml-1">Save</span>
            </button>

            <button type="button" class="btn btn-sm btn-secondary ml-1" @click="cancel">
              <font-awesome-icon icon="ban" />
              <span class="ml-1">Cancel</span>
            </button>
          </section>
        </div>
      </div>
    </div>

    <hr>

    <section id="module-loader-component" v-if="isLoading">
      <div class="row">
        <div class="col-12">
          <base-component-loader></base-component-loader>
        </div>
      </div>
    </section>

    <section id="module-header" v-if="!isLoading">
      <div class="row no-gutters text-left mt-2">
        <div class="col-md-6">
          <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="col-12">
                  <h4 class="font-weight-bold mb-0">{{ user.siName }}</h4>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label class="col-form-label font-weight-bold">ASSIGNED VESSEL</label>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="module-searching" v-if="isEditable && !isLoading">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <vue-multiselect
                v-model="selectedVessels"
                tag-placeholder="Add new vessel assign"
                placeholder="Search vessel name here ..."
                :custom-label="customTagLabel"
                track-by="id"
                :options="thisVesselKeys"
                :multiple="true"
                :options-limit="1000"
                :taggable="false">
            </vue-multiselect>
          </div>
        </div>
      </div>
    </section>

    <section id="module-table-list" v-if="!isEditable && !isLoading">
      <div class="row no-gutters text-left mt-2">
        <div class="col-md-6">
          <base-table>
            <template slot="table-header">
              <tr>
                <th style="width: 5%" class="text-center align-middle">#</th>
                <th style="width: 25%" class="text-center align-middle">Vessel Name</th>
                <th style="width: 25%" class="text-center align-middle">Created at</th>
                <th style="width: 15%" class="text-center align-middle">
                  <button type="checkbox" class="btn btn-xs btn-info" name="CheckAll" id="check-all"  @click="checkAll">
                   <span class="small">  {{isCheckAll ? 'UnCheck All' : 'Check All'}}</span>
                  </button>
                </th>
              </tr>
            </template>

            <template slot="table-body">
              <tr v-if="!user.assignedVessels">
                <td colspan="4">No record..</td>
              </tr>

              <tr v-else v-for="(vessel,index) in user.assignedVessels" :key="vessel.id">
                <td class="p-1 text-center align-middle">
                  {{ index + 1 }}
                </td>
                <td class="p-1 text-left align-middle pl-lg-4">
                  {{ vessel.vesselName }}
                </td>

                <td class="p-1 text-center align-middle">
                  {{ vessel.createdAt }}
                </td>
                <td class="p-1 text-center align-middle">
                  <input type="checkbox" class="larger" :id="`vessel-checkbox`+index" @change="updateCheckAll" v-model="deletedVessels" :value="vessel.id" />
                </td>
              </tr>
            </template>
          </base-table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import {AppMixins} from '../../../mixins/app.mixins';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'SIAccountView',

  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      userId: this.$route.params.userId,
      selectedVessels: [],
      isEditable: false,
      deletedVessels: [],
      isCheckAll: false,
    };
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'getAssignedVessels',
          'reset_user',
          'addAssignedVessels',
          'deleteAssignedVessels',
        ],
    ),

    customTagLabel({name}) {
      return `${name}`;
    },

    add() {
      this.isEditable = !this.isEditable;
    },

    async save() {
      let msgHtml = '<span>Are you want to save changes made?</span>';
      if (await this.questionFormAlert(msgHtml, 'Assigned vessels')) {
        const payload = {
          userId: this.userId,
          vessels: this.selectedVessels,
        };
        await this.addAssignedVessels(payload).then((r) => {
          this.selectedVessels = [];
          this.isEditable = false;
        });
      }
    },

    cancel() {
      this.isEditable = !this.isEditable;
      this.selectedVessels = [];
    },

    checkAll() {
      console.log('Check all')
      this.isCheckAll = !this.isCheckAll;
      if (this.isCheckAll) {
        this.user.assignedVessels.forEach((v, k) => {
          this.deletedVessels.push(v.id);
        });
      }else {
        this.deletedVessels = [];
      }
    },

    updateCheckAll() {
      if(this.deletedVessels.length == this.user.assignedVessels.length){
        this.isCheckAll = true;
      }else{
        this.isCheckAll = false;
      }
    },

    async del() {
      let msgHtml = '<span>Are you sure you want to delete this record?</span>';
      if (await this.questionFormAlert(msgHtml, 'Delete Record', 3)) {
        const payload = {
          userId : this.userId,
          vesselsId : this.deletedVessels
        }
        this.deleteAssignedVessels(payload).then((r)=>{
          if(r){
            this.successFormAlert('Delete record successfully')
            this.isCheckAll = false;
            this.deletedVessels = [];
          }
        })
      }
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'isLoading',
          'user',
          'objVesselKeys',
        ],
    ),

    thisVesselKeys() {
      let filtered = this.objVesselKeys.filter((v, index) => {
        if (this.user.hasOwnProperty('assignedVessels')) {
          return this.user.assignedVessels.filter((k, index) => {
            return k.vesselId == v.id;
          }).length == 0;
        }
      });
      return filtered;
    },
  },

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
    if (!this.user) {
      this.getAssignedVessels(this.userId);
    }
    ;
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
    this.reset_user();
  },
};
</script>

<style scoped>
input[type="checkbox"].larger {
  transform: scale(1.5) !important;
}
</style>
